export const getPlaceholder = (type: string): string => {
  switch (type) {
    case "string":
      return "Escribe un valor para comparar";
    case "number":
      return "Escribe un número para comparar";
    case "boolean":
      return "Elige una variable para comparar";
    case "date":
      return "Elige una fecha para comparar";
    case "array":
      return "Escribe un valor para comparar";
    default:
      return "Seleccione un valor";
  }
};

export const getRestrictionFunction = (
  type: string,
): ((val: string) => string) => {
  switch (type) {
    case "string":
      return (val) => val;
    case "number":
      return (val) => {
        // Use regex to match valid number format with max 4 decimal places
        const match = val.match(/^\d*\.?\d{0,4}/);
        return match ? match[0] : "";
      };
    case "positive-integer":
      return (val) => {
        //remove all non-digit characters and ensure it's a positive integer
        const cleaned = val.replace(/\D/g, "");
        return cleaned.startsWith("0") ? cleaned.slice(1) : cleaned;
      };
    default:
      return (val) => val;
  }
};
